import { onboardingApi } from '@features/onboarding/utility-setup/api';
import { ApiEndpoints } from '@shared/api/api-endpoints';
import { authApiClient, cxApiClient, onboardingApiClient, bxApiClient } from '@shared/api/clients/apiClientFactory';


export const CXCxDashboardApi = {
  getSummary: async (params: { remote_utility_id: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'cx',
      'consumer-summary-card',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  // Revenue trend data
  getRevenueTrend: async (params: { remote_utility_id: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'cx',
      'revenue-trend',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  // Service trend data  
  getServiceTrend: async (params: { remote_utility_id: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'cx',
      'service-trend',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  // Consumption usage data (uses bxApiClient for BX API)
  getConsumptionUsage: async (params: { 
    remote_utility_id: any; 
    utility_service: string 
  }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'bx',
      'consumption-usage',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
        qs.push('utility_service', params.utility_service);
      }
    );
    const response = await bxApiClient.get(url);
    return response.data;
  },

  // Consumer card details
  getConsumerCardDetail: async (params: { remote_utility_id: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'cx',
      'consumer-card-detail',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  // Outstanding summary
  getOutstandingSummary: async (params: { remote_utility_id: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'cx',
      'outstanding/summary',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },

  // Monthly support summary
  getMonthlySupportSummary: async (params: { remote_utility_id: any }): Promise<any> => {
    const url = ApiEndpoints.createUrlWithQueryParameters(
      'cx',
      'monthly-support-summary',
      (qs) => {
        qs.push('remote_utility_id', params.remote_utility_id);
      }
    );
    const response = await cxApiClient.get(url);
    return response.data;
  },
};